import { getDoc, doc, getDocs, collection, deleteDoc } from 'firebase/firestore';
import { db } from "../../Firebase/firebaseConfig/firebase";

const productosCollection = collection(db, "Productos");


export async function getProductoById(id) {
    const productoDoc = doc(productosCollection, id);
    const producto = await getDoc(productoDoc);
    return producto;
}

export async function getProductos() {
    const data = await getDocs(productosCollection);
    return (data.docs.map((doc) => ({ ...doc.data(), id: doc.id })))
}

export async function deleteProducto(id) {
    const productoDoc = doc(productosCollection, id);
    await deleteDoc(productoDoc);
}
